import {
    REQUEST_ADMIN_VIDEOMANUALS,
    RECEIVE_ADMIN_VIDEOMANUALS,
    UPDATE_ADMIN_VIDEOMANUALS,
    ERROR_ADMIN_VIDEOMANUALS
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem, reloadVideomanuals} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import axios from 'axios'

function request() {
    return {
        type: REQUEST_ADMIN_VIDEOMANUALS
    };
}

export function receive(data) {
    return {
        type: RECEIVE_ADMIN_VIDEOMANUALS,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_ADMIN_VIDEOMANUALS,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_ADMIN_VIDEOMANUALS,
        id,
        payload: data,
        updateType
    }
}

export function getAdminVideomanuals(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().adminVideomanuals, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'admin/videomanuals',
                params
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getAdminVideomanual(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('adminVideomanual'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'admin/videomanuals/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createAdminVideomanual(data) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'POST',
                url: fetchUrl + 'admin/videomanuals',
                data
            }).then(res => {
                dispatch(reloadVideomanuals())
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateAdminVideomanual(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('adminVideomanual'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'admin/videomanuals/' + id,
                data
            }).then(res => {
                dispatch(reloadVideomanuals())
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteAdminVideomanual(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'admin/videomanuals/' + id
            }).then(res => {
                dispatch(reloadVideomanuals())
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}
